<template>
<content-layout :title="title" :tabs="tabs" v-model="activeTab" :spin-show='spinShow'>
    
    <div slot="slogan"></div>
        <div class="activity-item mgui-container" slot="/apply/borrowing">
            <div class="filter-row flex">
                <div class="flex-1">
                    <RadioGroup v-model="params.status" type="button" @on-change="handleStatus">
                        <Radio :label="-1">全部</Radio>
                        <Radio v-for="item in status" :key="item.value" :label="item.value">{{ item.name }}</Radio>
                    </RadioGroup>
                    <Divider type="vertical"></Divider>
                    <Button icon="md-add" type="primary" @click="createBorrowing">借款申请</Button>
                </div>
                <div >
                    <RadioGroup v-model="viewModel" type="button" @on-change="handleStatus">
                        <Radio :label="'list'"><Icon type="md-list" /> 列表</Radio>
                        <Radio :label="'grid'"><Icon type="md-grid" /> 网格</Radio>
                    </RadioGroup>
                </div>
        </div>
        
        <Table v-if="result.data.length>0 && viewModel=='list'" :columns="columns" :data="result.data"></Table>
        <div class='borrow-list' v-if="result.data.length>0 && viewModel == 'grid'">
            <template  v-for="(item, index) in result.data">
                <div class="borrow-card" :key="index">
                    <h3>
                            <span>项 目 借 款 单</span>
                    </h3>
                    <div class="info">
                        <span>申请人：{{item.user_name}}</span> <span>创建时间：{{item.updated_at}}</span>
                    </div>
                    <table class="borrow-table">
                        <tr>
                            <th>借款人:</th>
                            <td>{{ item.user_name }}</td>
                            <th>借款日期:</th>
                            <td>{{ item.time || item.updated_at }}</td>
                        </tr>
                        <tr>
                            <th>部门:</th>
                            <td colspan="3">
                                {{ item.department_name }} {{ item.project_name }}
                            </td>
                        </tr>
                        <tr>
                            <th>借款金额:</th>
                            <td>¥ {{ Number(item.amount).toFixed(2) }}</td>
                            <th>已打款:</th>
                            <td>¥ {{ Number(item.paid).toFixed(2) }}</td>
                        </tr>
                        
                        <tr>
                            <th>备注</th>
                            <td colspan="3">{{ item.remarks }}</td>
                        </tr>
                    </table>
                    <div class="approval">
                        <Tag :color="status[item.status]['type']">{{status[item.status]['name']}}</Tag>
                        <Poptip confirm title="确定删除单据吗？" @on-ok="delItem(item.id)">
                            <Button v-if="item.status==0||item.status==2" size="small">删除</Button>
                        </Poptip>
                    </div>
                </div>
            </template>
        </div>
        <div class="pager">
            <Page :current="result.page" :page-size="result.per_page" :total="result.total" @on-change="pagerChange"></Page>
        </div>
        <loading :visible="result.length<=0" :icon="loadIcon" :text="loadText"></loading>
        <Modal v-model="borrowingVisible" width="660" footer-hide>
            <div class="borrow-card" style="position: relative">
                <h3>
                        <span>项 目 借 款 单</span>
                </h3>
                <!--<div style="font-size:13px;color:#666;padding:10px 0 5px;margin-right:10px;margin-top:-40px">
                    申请人：{{formData.user}}<br>创建时间：{{item.updated_at}}
                </div>-->
                <Form ref="formItem" :model="formData" :rules="ruleData">
                    <table class="borrow-table">
                        <tr>
                            <th>借款人:</th>
                            <td><FormItem label="" prop="user_name" ><Input v-model="formData.user_name" /></FormItem></td>
                            <th>借款日期:</th>
                            <td><DatePicker type="date" v-model="formData.time" placeholder="选择报销日期" format-value></DatePicker></td>
                        </tr>
                        <tr>
                            <th>部门:</th>
                            <td colspan="3">
                                <FormItem label="" prop="department_id" >
                                    <Cascader v-model="deptIds" @on-change="handleChange" placeholder="选择项目组" :data="departments">
                                        
                                    </Cascader>
                                </FormItem>
                            </td>
                        </tr>
                        <tr>
                            <th>借款金额:</th>
                            <td colspan="3">
                                <FormItem label="" prop="amount" >
                                    <InputNumber style="width:100%" placeholder="请输入借款金额" v-model="formData.amount"/>
                                </FormItem>
                            </td>
                        </tr>
                        
                        <tr>
                            <th>备注</th>
                            <td colspan="3"><Input type="textarea" placeholder="备注" v-model="formData.remarks"/></td>
                        </tr>
                    </table>
                </Form>
            </div>
            <div class="borrow-btn">
                <Button type="primary" @click="submit('formItem')" :disabled="isDisabled">提交申请</Button>&nbsp;
                <Button @click="borrowingVisible=false">取消</Button>
            </div>
        </Modal>
    </div>
</content-layout>
</template>

<script>
    import {
        formatTime
    } from '../util/filter'
    import {
        fetch,
        put,
        post,
        del
    } from '../fetch/api'


    let formItem = {
        id: 0,
        'user_name': '',
        'user_id': 0,
        'amount': null,
        'department_id': [],
        'department_name': null,
        'project_name': null,
        'project_id': null,
        'approval_id': null,
        'remarks': null
    }

    const status = [
        { 'name': '待审批', 'value': 0, 'type': 'default' },
        { 'name': '待打款', 'value': 1, 'type': 'primary' },
        { 'name': '未通过', 'value': 2, 'type': 'warning' },
        { 'name': '已打款', 'value': 3, 'type': 'success' }
    ]

    import { mapState } from "vuex"

    export default {
        name: 'Apply',
        components: {
            ContentLayout: resolve => {
                require(['../components/ContentLayoutComponent'], resolve)
            },
            Loading: resolve => {
                require(['../components/LoadingComponent'], resolve)
            }
        },
        data() {
            let token = localStorage.getItem('token')

            return {
                title: '借款',
                tabs: [{
                        'title': '借款列表',
                        'key': '/apply/borrowing',
                        'visible': true
                    }
                ],
                activeTab: '/apply/borrowing',
                borrowingVisible: false,
                spinShow: true,
                //  status: 0正常 1已审批 2未通过 3 已打款
                status: status,
                viewModel: 'list',
                columns: [
                    {
                        title: '借款人',
                        key: 'user_name'
                    },
                    {
                        title: '部门',
                        key: 'department_name'
                    },
                    {
                        title: '项目',
                        key: 'project_name'
                    },
                    {
                        title: '借款金额',
                        key: 'amount'
                    },
                    {
                        title: '已打款',
                        key: 'paid'
                    },
                    {
                        title: '借款时间',
                        key: 'time'
                    },
                    {
                        title: '最后更新',
                        key: 'updated_at'
                    },
                    {
                        title: '状态',
                        key: 'status',
                        sortable: true,
                        render: (h, params) => {
                            return h('div', [
                                h('Tag', {
                                    props: {
                                        color: status[params.row.status]['type'],
                                        // size: 'small'
                                        type: 'border'
                                    }
                                }, status[params.row.status]['name'])
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'status',
                        sortable: true,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        size: 'small',
                                        type: 'primary',
                                        disabled: (params.row.status!=2&&params.row.status!=0),
                                    },
                                    style: {marginRight: '5px'},
                                    on: {
                                        click: () => {
                                            this.edit(params.row)
                                        }
                                    }
                                }, '编辑'),
                                (params.row.status==2||params.row.status==0)?h('Poptip',
                                {
                                    props:{
                                        confirm: true,
                                        title: '确定删除吗？',
                                        transfer: true,
                                        placement: 'top',
                                        width: 200
                                    },
                                    on: {
                                        'on-ok': () => {
                                            this.delItem(params.row.id)
                                        }
                                    }
                                },
                                [h('Button', {
                                    props: {
                                        size: 'small'
                                    }
                                }, '删除')]): null
                            ]);
                        }
                    }
                ],
                isDisabled: false,
                exportTime: [],
                token: token,
                loadText: '正在加载...',
                loadIcon: 'refresh',
                ruleData: {
                    time: [{
                        required: true,
                        type: 'date',
                        message: '请选择借款时间',
                        trigger: 'change'
                    }],
                    user_name: [{
                        required: true,
                        message: '请输入借款人姓名',
                        trigger: 'change'
                    }],
                    department_id: [{
                        required: true,
                        type: 'number',
                        message: '请选择部门',
                        trigger: 'change'
                    }],
                    amount: [{
                        required: true,
                        type: 'number',
                        message: '请输入金额',
                        trigger: 'blur'
                    },{
                        type: 'number',
                        min: 1,
                        message: '请输入大于 0 的金额',
                        trigger: 'blur'
                    }]
                },
                result: {
                    data: [],
                    page: 0,
                    per_page: 15,
                    total: 0
                },
                errorInfo: '',
                params: {
                    status: -1
                },
                deptIds: [],
                projects: [],
                formData: JSON.parse(JSON.stringify(formItem))
            }
        },
        computed: {
            ...mapState({
                departments: state => state.department,
                userinfo: state => state.userInfo,

            })
        },
        watch: {
            $route(to) {
                this.routeChange(to)
            },
            // 'formData.department_id'(val, old){
            //     if (val!=old) {
            //         this.formData.project_name = ''
            //         this.formData.project_id = null
            //         this.projects = this.departments.find(item => item.value === this.formData.department_id).children
            //     }
            // }
        },
        mounted() {
            this.fetchData()
        },
        filters: {
            formatTime(time) {
                if (!time) return '--'
                let date = new Date(time * 1000)
                return formatTime(date, 'yyyy-MM-dd hh:mm')
            }
        },
        methods: {
            handleChange(value) {
                this.formData.department_id = value[0]
                this.formData.project_id = value[value.length - 1]
                const dept = this.departments.find(item => item.value === this.formData.department_id)
                this.formData.department_name = dept.label
                this.formData.project_name = dept.children.find(item => item.value === this.formData.project_id).label
            },
            createBorrowing(){
                this.borrowingVisible = true
                const dept = this.departments.find(item => item.value == this.userinfo.department)
                const pro = (dept && dept.children && dept.children.length > 0) ? dept.children.find(item => item.value == this.userinfo.project) : {label: '', value: 0}
                this.deptIds = [dept.value, pro.value]
                this.formData = {
                    ...this.formData,
                    user_id: this.userinfo.id,
                    user_name: this.userinfo.username,
                    department_name: dept.label||null,
                    project_name: pro.label||null,
                    department_id: dept.value||null,
                    project_id: pro.value||null,
                    amount: null,
                    time: new Date()
                }
            },
            fetchDepartment() {
                this.$store.dispatch('setDepartment', false)
            },
            handleStatus() {
                this.fetchData()
            },
            async delItem(id) {
                await del(`borrowing/${id}`)
                this.fetchData()
            },
            edit(item) {
                // console.log(item)
                this.borrowingVisible = true
                // data['status'] = data['agree']
                this.deptIds = item.project_id&&item.department_id?[item.department_id,item.project_id] : []
                this.formData = {
                    ...item
                }
            },
            submit(name) {
                this.isDisabled =  true
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        const time = formatTime(new Date(this.formData.time), 'yyyy-M-d')
                        if (this.formData.id === 0) {
                            post('borrowing', {...this.formData, time: time}).then(res => {
                                if (res.status === 'success') {
                                    this.fetchData()
                                    this.borrowingVisible = false
                                }
                            })
                        } else {
                            put(`borrowing/${this.formData.id}`, {...this.formData, time: time}).then(res => {
                                if (res.status === 'success') {
                                    this.fetchData()
                                    this.borrowingVisible = false
                                }
                            })
                        }
                        setTimeout(() => {
                            this.isDisabled = false
                        }, 2000)
                    }
                })
            },
            pagerChange(val) {
                this.page.page = val
                this.fetchData()
            },
            fetchData() {
                fetch(`borrowing`, {params: this.params}).then(res => {
                    this.result = res
                })
                this.spinShow = false
            },
            routeChange(route) {
                let action = route.params.action
                if (action === undefined) {
                    // this.fetchData()
                    this.spinShow = false
                }
            }
        }
    }
</script>

<style scope>
.borrow-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.borrow-card .info{
    display:flex;
    justify-content: space-between;
}
.borrow-list .borrow-card {
    border: 1px solid #e8e8e8;
    min-width: 32%;
    margin: 0 10px 10px;
}
.borrow-card .approval{padding: 10px 0 0}
.borrow-card {
    padding: 20px;
    margin-bottom: 20px;
}
.borrow-card .ivu-form-item{margin-bottom: 0}
.borrow-card .ivu-form-item-error-tip{left: auto;right:15px;top:-25px;background:#fff;border-radius:4px}
.borrow-card h3{
    margin-bottom: 15px;
    text-align: center;
}

.borrow-table {
    width: 100%;
    border-collapse: collapse;
}

.borrow-table th {
    width: 80px;
    text-align: right;
    background: #f7f7f7;
    font-size: 12px;
}

.borrow-table th,
.borrow-table td {
    border: 1px solid #78a9b1;
    padding: 5px 5px;
}
.borrow-btn{
    padding: 0 20px 20px;
    margin-top: -10px;
}

.users-count {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 4px;
    /*background: #f7f7f7;*/
    color: #fff;
    padding: 5px 10px;
}

.filter-row-item {
    display: inline-block;
}

.users-count span,
.users-count a {
    margin-right: 10px
}

.leader-select {
    border: 1px solid #ccc;
    background: #f7f7f7;
}

.users-count a {
    color: #fff;
    text-decoration: underline
}

.collapse-active .ivu-collapse-content {
    display: block !important
}

.collapse-active .ivu-collapse-header {
    background: #ffeccf
}

@media (max-width: 640px) {
    .filter-row-item {
        display: block;
        margin-bottom: 10px
    }

    .users-count {
        width: 200px;
    }
}
</style>
